import { Magnet } from "@dreamhub/designsystem/icons";
import PageLayout from "@/pages/settings/components/PageLayout";
import { GeneralTab } from "@/pages/settings/components/leadsSettings/GeneralTab";
import { FieldManagementTab } from "@/pages/settings/components/dealsSettings/FieldManagement/FieldManagementTab";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LeadSettingsTabs } from "@/pages/settings/types";
import { useSearchParams } from "react-router-dom";
import { EntityType } from "@/services/hooks/entities/useEntityType";

const TRANSLATION_KEY = "settings.leads";
const TRANSLATION_KEY_TABS = "settings.leads.tabs";

export const LeadSettings = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [tabValue, setTabValue] = useState<LeadSettingsTabs>(() => {
    const tabParam = searchParams.get("tab");
    return Object.values(LeadSettingsTabs).includes(
      tabParam as LeadSettingsTabs
    )
      ? (tabParam as LeadSettingsTabs)
      : LeadSettingsTabs.GENERAL;
  });

  useEffect(() => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", tabValue);
      return params;
    });
  }, [tabValue, setSearchParams]);

  const getTabOptions = () => {
    const options: Record<string, string> = {};
    Object.values(LeadSettingsTabs).forEach((tab) => {
      options[tab] = t(`${TRANSLATION_KEY_TABS}.${tab}`);
    });

    return options;
  };

  const onTabChange = (newTabValue: string) => {
    setTabValue(newTabValue as LeadSettingsTabs);
  };

  const renderTabContent = () => {
    switch (tabValue) {
      case LeadSettingsTabs.GENERAL:
        return <GeneralTab />;
      case LeadSettingsTabs.FIELD_MANAGEMENT:
        return <FieldManagementTab entityType={EntityType.LEAD} />;
      default:
        return <FieldManagementTab entityType={EntityType.LEAD} />;
    }
  };

  return (
    <PageLayout
      data-test="settings-leads-page"
      title={t(`${TRANSLATION_KEY}.title`)}
      logoIcon={<Magnet />}
      tabs={{
        options: getTabOptions(),
        defaultValue: tabValue,
        valueSelected: onTabChange
      }}
    >
      {renderTabContent()}
    </PageLayout>
  );
};
